export default __webpack_public_path__ + "static/Metal_Tree_Platform-293f10245e7da26d5f9e52c36664da48.png";